import React, {useState, useEffect, useRef} from "react";
import {DEFAULT_BLUE} from "../../../constants/general-constants";
import {STRINGIFY} from "../../../constants/general-constants";
import {functions} from "../../../constants/common-functions";

export default function AdministrationClientHomeLink({id, name, link,color, sequence}){
	
	useEffect(() => {
		refColor.current.value = color;
		refSequence.current.value = sequence;
	}, [id]);
	
	const refColor = useRef(null);
	const refSequence = useRef(null);
	
	const thisContainer = {
		display:"flex",
		height:"60px",
		alignItems:"center"
	};
	
	const nameContainer = {
		display:'flex',
		fontSize:"12px",
		color:"black",
		width:"200px"
	};
	
	const thisText = {
		display:"flex",
		height:"30px",
		border:"1px solid #ddd",
		paddingLeft:"10px",
		backgroundColor:"white",
		color:"black",
		fontSize:"12px",
		marginRight:"10px"
	};
	
	const blueButton = {
		display:"flex",
		width:"80px",
		height:"30px",
		borderRadius:"4px",
		alignItems:"center",
		justifyContent:"space-around",
		color:"white",
		fontSize:'12px',
		cursor:"pointer",
		backgroundColor:DEFAULT_BLUE
	};
	
	const submitThis = () => {
		try{
			let  submitObj = {
				id:id,
				link:link,
				name:name,
				sequence:refSequence.current.value,
				color:refColor.current.value
			}
				
				functions.submitAjax("/resolution/clienthomepagelinksave", 
					submitObj, saveEnd, STRINGIFY, handleSubmitError);
		}
		catch(e){
			alert(e);
		}
	};
	
	const handleSubmitError = (e) => {
		console.log(e);
	};
	
	const saveEnd = () => {
		
	};
	
	
	return (
		<div style={thisContainer}>
			<div style={nameContainer}>
				{name}
			</div>
			<input type="text" style={thisText} ref={refColor}/>
			<input type="text" style={thisText} ref={refSequence}/>	
			<div style={blueButton} onClick={submitThis}>
				Submit
			</div>
		</div>
		
	);
}